import { Component, ElementRef, OnInit, ViewChild } from '@angular/core';
import { FormArray, FormBuilder, FormGroup, FormControl, Validators, ReactiveFormsModule } from '@angular/forms';
import { HttpClient } from '@angular/common/http';
import { LocalStorageService } from 'ngx-webstorage';
import { Router, RouterLink, RouterLinkActive } from '@angular/router';
import { ConsumerClaimantService } from '../../../services/consumer-claimant/consumer-claimant.service';
import { ConsumerClaimantsModel } from '../../../models/consumerclaimantsmodel';
import { NgxSpinnerModule, NgxSpinnerService } from 'ngx-spinner';
import { CommonModule } from '@angular/common';
import { RecaptchaModule, RecaptchaFormsModule } from 'ng-recaptcha-2';
import { NgxMaskDirective, provideNgxMask } from 'ngx-mask';
import { NgxTrimDirectiveModule } from 'ngx-trim-directive';

import { DrugService } from '../../../services/drug/drug.service';
import { DrugModel } from '../../../models/drugmodel';
import { inject } from '@angular/core/primitives/di';

@Component({
  selector: 'app-consumer-claimants',
  templateUrl: './consumer-claimants.html',
  styleUrls: ['./consumer-claimants.css'],
  imports: [ReactiveFormsModule, CommonModule, RouterLinkActive, RouterLink, NgxTrimDirectiveModule, NgxMaskDirective, NgxSpinnerModule, RecaptchaModule, RecaptchaFormsModule],
  providers: [provideNgxMask()], // Provide at the component level
})
export class ConsumerClaimants implements OnInit{
  @ViewChild('listofFiles') tableRef: ElementRef;
  @ViewChild('fileInput') fileInput: ElementRef;
  field1Value: string = '';
  piList: any = [];
  showDivACH: boolean = false;
  submitted = false;
  clicked = false;
  clickedOnce = false;
  addButtonClicked = false;
  showDivOtherHealthType: boolean = false;
  allCompanyHealthTypes: any = [];
  allInsuranceQuestion: any = [];
  allStates: any = [];
  supportingDocuments: File[] = [];
  claimantsInformation: FormGroup;
  submittedClaim: ConsumerClaimantsModel;
  authenticatedUser: ConsumerClaimants;
  response: string | undefined;
  changed = false;
  dateLoaded: Date;
  claimStartTime: string;
  claimEndTime: string;
  showDivSubmittalErrorMessage: boolean = false;
  showDivSectionB: boolean = false;
  submitClicked: boolean = false;


  validation_TransactionalClaimsDataAvailableErrorMessage = {
  
    totalAmountPaid: [
      { type: 'required', message: 'This Field is required' },
      { type: "maxlength", message: "Field cannot be more than 15 digits" },
      { type: "pattern", message: "Only use numbers with optional period (.) and up to 4 digits past decimal" }
    ],
    genericDrugNameAndListNumber: [
      { type: 'required', message: 'This Field is required' },
    ],
  };

  constructor(
    private fb: FormBuilder,
    private httpClient: HttpClient,
    private storage: LocalStorageService,
    private router: Router,
    private spinner: NgxSpinnerService,
    private consumerClaimantService: ConsumerClaimantService) { }

  ngOnInit() {
    this.dateLoaded = new Date();
    this.claimStartTime = this.dateLoaded.toLocaleTimeString();
    this.loadAllStates();
    this.loadAllCompanyHealthTypes();



    this.claimantsInformation = this.fb.group({
      name1: ['', Validators.compose([Validators.required, Validators.maxLength(50), Validators.minLength(2), Validators.pattern("^[a-zA-Z0-9 .\\[\\]/#&'()-]+$")])],
      name2: ['', Validators.compose([Validators.maxLength(50), Validators.minLength(2), Validators.pattern("^[a-zA-Z0-9 .\\[\\]/#&'()-]+$")])],
      street1: ['', Validators.compose([Validators.required, Validators.maxLength(50), Validators.minLength(2), Validators.pattern("^[a-zA-Z0-9 .\\[\\]/#&'()-]+$")])],
      street2: ['', Validators.compose([Validators.maxLength(50), Validators.minLength(2), Validators.pattern("^[a-zA-Z0-9 .\\[\\]/#&'()-]+$")])],
      city: ['', Validators.compose([Validators.required, Validators.maxLength(40), Validators.minLength(2), Validators.pattern("^[a-zA-Z0-9 .\\[\\]/#&'()-]+$")])],
      state: ['', Validators.compose([Validators.required])],
      zip: ['', Validators.compose([Validators.required, Validators.pattern("^[0-9]{5}(?:-[0-9]{4})?$")])],
      primaryPhone: ['', Validators.compose([Validators.required, Validators.maxLength(10), Validators.minLength(10), Validators.pattern("^[0-9]+$")])],
      primaryPhoneType: ['', Validators.compose([Validators.required])],
      emailAddress: ['', Validators.compose([Validators.required, Validators.maxLength(255), Validators.pattern("[a-zA-Z0-9_\\.-]+@([a-zA-Z0-9-]+\\.)+[a-zA-Z]{2,6}$")])],

      optPaymentRadio: ['', Validators.compose([Validators.required])],
      achAccountType: [''],
      achRoutingNumber: [''],
      achAccountNumber: [''],

      classMemberConfirmation: ['', Validators.compose([Validators.required])],
      signatureConfirmation: ['', Validators.compose([Validators.required])],

      signature: ['', Validators.compose([Validators.required, Validators.maxLength(50), Validators.minLength(2), Validators.pattern("^[a-zA-Z0-9 .\\[\\]/#&'()-]+$")])],
      googleRecaptchaToken: ['', Validators.compose([Validators.required])],
      purchaseInformation: this.fb.array([]),

    });

    this.claimantsInformation.get('primaryPhone')?.valueChanges.subscribe(value => {
      const dropdownControl = this.claimantsInformation.get('primaryPhoneType');
      if (value) {
        dropdownControl?.setValidators([Validators.required]);
      } else {
        dropdownControl?.clearValidators();
      }
      dropdownControl?.updateValueAndValidity();
    });

  }
  resolved(captchaResponse: string) {
    this.response = captchaResponse;
  }

  getPaymentRadioValue($event) {
    // if you need the event source and value it can be accessed.
    console.log($event.target.value);
    if ($event.target.value === 'ACH') {
      this.showDivACH = true;
      //this.stepFiveForm.get('achAccountType').reset();
      //this.stepFiveForm.get('achAccountType').clearValidators();
      //this.stepFiveForm.get('achAccountType').updateValueAndValidity();

      //this.stepFiveForm.get('achRoutingNumber').reset();
      //this.stepFiveForm.get('achRoutingNumber').clearValidators();
      //this.stepFiveForm.get('achRoutingNumber').updateValueAndValidity();

      //this.stepFiveForm.get('achAccountNumber').reset();
      //this.stepFiveForm.get('achAccountNumber').clearValidators();
      //this.stepFiveForm.get('achAccountNumber').updateValueAndValidity();

      this.claimantsInformation.get('achAccountType').setValidators(Validators.compose([Validators.required]));
      this.claimantsInformation.get('achRoutingNumber').setValidators(Validators.compose([Validators.required, Validators.maxLength(9), Validators.minLength(9), Validators.pattern("^[0-9]+$")]));
      this.claimantsInformation.get('achAccountNumber').setValidators(Validators.compose([Validators.required, Validators.minLength(4), Validators.maxLength(17), Validators.pattern("^[0-9]+$")]));
    }
    if ($event.target.value === 'Zelle') {
      this.showDivACH = false;
      this.claimantsInformation.get('achAccountType').reset();
      this.claimantsInformation.get('achAccountType').clearValidators();
      this.claimantsInformation.get('achAccountType').updateValueAndValidity();

      this.claimantsInformation.get('achRoutingNumber').reset();
      this.claimantsInformation.get('achRoutingNumber').clearValidators();
      this.claimantsInformation.get('achRoutingNumber').updateValueAndValidity();

      this.claimantsInformation.get('achAccountNumber').reset();
      this.claimantsInformation.get('achAccountNumber').clearValidators();
      this.claimantsInformation.get('achAccountNumber').updateValueAndValidity();
    }
    if ($event.target.value === 'PayPal') {
      this.showDivACH = false;
      this.claimantsInformation.get('achAccountType').reset();
      this.claimantsInformation.get('achAccountType').clearValidators();
      this.claimantsInformation.get('achAccountType').updateValueAndValidity();

      this.claimantsInformation.get('achRoutingNumber').reset();
      this.claimantsInformation.get('achRoutingNumber').clearValidators();
      this.claimantsInformation.get('achRoutingNumber').updateValueAndValidity();

      this.claimantsInformation.get('achAccountNumber').reset();
      this.claimantsInformation.get('achAccountNumber').clearValidators();
      this.claimantsInformation.get('achAccountNumber').updateValueAndValidity();
    }
    if ($event.target.value === 'Venmo') {
      this.showDivACH = false;
      this.claimantsInformation.get('achAccountType').reset();
      this.claimantsInformation.get('achAccountType').clearValidators();
      this.claimantsInformation.get('achAccountType').updateValueAndValidity();

      this.claimantsInformation.get('achRoutingNumber').reset();
      this.claimantsInformation.get('achRoutingNumber').clearValidators();
      this.claimantsInformation.get('achRoutingNumber').updateValueAndValidity();

      this.claimantsInformation.get('achAccountNumber').reset();
      this.claimantsInformation.get('achAccountNumber').clearValidators();
      this.claimantsInformation.get('achAccountNumber').updateValueAndValidity();
    }
    if ($event.target.value === 'Paper Check') {
      this.showDivACH = false;
      this.claimantsInformation.get('achAccountType').reset();
      this.claimantsInformation.get('achAccountType').clearValidators();
      this.claimantsInformation.get('achAccountType').updateValueAndValidity();

      this.claimantsInformation.get('achRoutingNumber').reset();
      this.claimantsInformation.get('achRoutingNumber').clearValidators();
      this.claimantsInformation.get('achRoutingNumber').updateValueAndValidity();

      this.claimantsInformation.get('achAccountNumber').reset();
      this.claimantsInformation.get('achAccountNumber').clearValidators();
      this.claimantsInformation.get('achAccountNumber').updateValueAndValidity();
    }
  }

  loadAllCompanyHealthTypes() {
    this.httpClient.get("assets/CompanyHealthTypes.json").subscribe(data => {
      /* console.log(data);*/
      this.allCompanyHealthTypes = data;
    })
  }

  //getValidators() {
  //  let one = this.claimantsInformation.get('name1').value;
  //  var two = this.claimantsInformation.get('street1').value;
  //  var three = this.claimantsInformation.get('city').value;
  //  var four = this.claimantsInformation.get('state').value;
  //  var five = this.claimantsInformation.get('zip').value;
  //  var six = this.claimantsInformation.get('primaryPhone').value;
  //  var seven = this.claimantsInformation.get('primaryPhoneType').value;
  //  var eight = this.claimantsInformation.get('classMemberConfirmation').value;
  //  var nine = this.claimantsInformation.get('totalNumberOfPrescriptions').value;
  //  var ten = this.claimantsInformation.get('totalAmountPaid').value;
  //  var eleven = this.claimantsInformation.get('signature').value;
  //  var twelve = this.claimantsInformation.get('googleRecaptchaToken').value;


  //  if ((one.value == true) && (two.value == true) && (three.value == true) && (four.value == true) && (five.value == true) && (six.value == true) && (seven.value == true)) {
  //    this.showDivSubmittalErrorMessage = false;
  //  }
  
  //}

  //getValidatorsB() {
  //  var eight = this.claimantsInformation.get('classMemberConfirmation').value;

  //  if ((eight == true)) {
  //    this.showDivSectionB = false;
  //  }

  //  if ((eight == false)) {
  //    this.showDivSectionB = true;
  //  }
  //}

  getPhoneType2Value() {
    this.changed = true;
    const primaryPhoneType = this.claimantsInformation.get('primaryPhoneType')?.value;

    if (primaryPhoneType !== '') {
      this.claimantsInformation.get('primaryPhone').setValidators(Validators.compose([Validators.required, Validators.maxLength(10), Validators.minLength(10), Validators.pattern("^[0-9]+$")]));
    } else {
      this.claimantsInformation.get('primaryPhone').clearValidators();
    }
    this.claimantsInformation.get('primaryPhone').updateValueAndValidity();
  }

  getCompanyHealthTypesValue($event) {
    // if you need the event source and value it can be accessed.
    console.log($event.target.value);
    if ($event.target.value === 'Other') {
      this.showDivOtherHealthType = true;
      this.claimantsInformation.get('otherCompanyHealthType').setValidators(Validators.compose([Validators.required, Validators.maxLength(50), Validators.minLength(2), Validators.pattern("^[a-zA-Z0-9 .\\[\\]/#&'()-]+$")]));
    }  
  }

  getInsuranceQuestion($event) {
    // if you need the event source and value it can be accessed.
    console.log($event.target.value);
  }


  loadAllStates() {
    this.httpClient.get("assets/States.json").subscribe(data => {
      /* console.log(data);*/
      this.allStates = data;
    })
  }

  get f() { return this.claimantsInformation.controls; }

  getFileDetails(e) {
    for (let i = 0; i < e.target.files.length; i++) {
      this.supportingDocuments.push(e.target.files[i]);
     /* console.log(e.target.files[i]);*/
    }
  }

  // Clear ClaimDetails Form Array Controls
  // resetFormArray() {
  //   this.purchaseInformation().clear();
  // }

  removeRow(i: number) {
    this.supportingDocuments.splice(i, 1);
    this.fileInput.nativeElement.value = null;
  }

  // Declare FormArray Function
  purchaseInformation(): FormArray {
    return this.claimantsInformation.get('purchaseInformation') as FormArray
  }

  // Create new Form Array
  newPurchaseInformations(): FormGroup {
    return this.fb.group({
      drugName: [''],
      genericDrugNameAndListNumber: ['', Validators.compose([Validators.required])],
      totalAmountPaid: ['', Validators.compose([Validators.required, Validators.maxLength(15), Validators.pattern(/^\d{0,15}(?:[.]\d{1,4})?$/)])],
    });
  }

  // Create a New Array Function
  purchaseInformationsARR(index) {
    this.piList = this.claimantsInformation.get('purchaseInformation') as FormArray;
    const formGroup = this.piList.controls[index] as FormGroup;
    return formGroup;
  }

  addpurchaseInformationData() {
    (<FormArray>this.claimantsInformation.get('purchaseInformation')).push(this.newPurchaseInformations());
  }

  removepurchaseInformationData(i: number) {
    this.purchaseInformation().removeAt(i)
  }

  // Create new Form Array
  newPurchaseInformationsPA(): FormGroup {
    return this.fb.group({
      genericDrugNameAndListNumber: ['', Validators.compose([Validators.required])],
      totalAmountPaid: ['', Validators.compose([Validators.required, Validators.maxLength(15), Validators.pattern(/^\d{0,15}(?:[.]\d{1,4})?$/)])],
    });
  }









  onSubmit() {
    this.submitted = true;


    // stop here if form is invalid
    if (this.claimantsInformation.invalid) {
      this.showDivSubmittalErrorMessage = true;
      return;

    }
    this.submitClicked = true;
    this.clicked = true;
    const claimant = this.claimantsInformation.value;
    this.dateLoaded = new Date();
    this.claimEndTime = this.dateLoaded.toLocaleTimeString();


    claimant.claimStartTime = this.claimStartTime;
    claimant.claimEndTime = this.claimEndTime;

    this.spinner.show();
    this.CreateClaimant(claimant);
  }

  CreateClaimant(claimant: ConsumerClaimantsModel) {
    this.consumerClaimantService.createClaimant(claimant).subscribe({
      next: (res) => {
        this.submittedClaim = res;
        this.SubmitDocuments(this.submittedClaim.claimNumber);
      },
      error: (err) => {
        console.error('Error creating claimant', err);
        this.spinner.hide();
      }
    });
  }

  SubmitDocuments(claimNumber: string) {
    this.consumerClaimantService.submitDocuments(this.submittedClaim.claimNumber, this.supportingDocuments).subscribe({
      next: () => {
        this.storage.store('claimant', this.submittedClaim);
        this.claimantsInformation.reset();
        this.spinner.hide();
        this.router.navigate(['/consumer-complete']);
      },
      error: (err) => {
        console.error('Error submitting documents', err);
        this.spinner.hide();
      }
    });
  }
}
